import { render } from "./section-content.vue?vue&type=template&id=15a72a54&scoped=true"
import script from "./section-content.vue?vue&type=script&lang=js"
export * from "./section-content.vue?vue&type=script&lang=js"

import "./section-content.vue?vue&type=style&index=0&id=15a72a54&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a72a54"],['__file',"src/components/notepad/parts/section-content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15a72a54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15a72a54', __exports__)) {
    api.reload('15a72a54', __exports__)
  }
  
  module.hot.accept("./section-content.vue?vue&type=template&id=15a72a54&scoped=true", () => {
    api.rerender('15a72a54', render)
  })

}


export default __exports__